module.exports = __webpack_public_path__ + "static/media/RL_LL_BONNIE_CHICA.539b9c1f.webp";